import React, { useState } from 'react'
import Fab from '@material-ui/core/Fab'
import Typography from '@material-ui/core/Typography'
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { makeStyles } from '@material-ui/core/styles'
import { styles } from './HelpButton.styles'
import ReportModal from '../ReportModal'

const useclasses = makeStyles(styles)

export default function HelpButton() {
  const classes = useclasses()
  const [showLabel, setShowLabel] = useState(false)
  const [open, setOpen] = useState(false)

  const navigateToTicket = () => {
    window.open('https://wa.me/5511989512418', '_blank')
  }

  return (
    <div className={classes.container} id="help-button">
      <Fab
        className={classes.fab}
        onMouseEnter={() => setShowLabel(true)}
        onMouseLeave={() => setShowLabel(false)}
        onClick={navigateToTicket}
      >
        <WhatsAppIcon size="large" className={classes.icon} />
      </Fab>
      <Typography className={showLabel ? classes.helpButtonLabel : classes.hidden}>
        Precisa de ajuda?
      </Typography>
      <ReportModal open={open} setOpen={setOpen} />
    </div>
  )
}
